import React from 'react';
import { PapiDeviation, PapiNetworkbarStrip } from '@wix/da-papi-types';
import { OverlayContextProvider } from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import type { BrowseItem } from '../../../types/api';
import BrowseGrid from './BrowseGrid';
import BrowseTorpedo from './BrowseTorpedo';
import BrowseDuperContext from './BrowseDuperContext';
import { BrowseLayout } from '../../../constants';
import PagingWrapper from './PagingWrapper';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import BrowseFeed from './BrowseFeed';
import BrowseStacks from './BrowseStacks';
import { StreamItems } from '../../types/stream';
import Strips from '../Strips';

export interface Props {
  streamId: string;
  searchType?: string;
  layout: BrowseLayout;
  isInfiniteScroll?: boolean;
  strips?: PapiNetworkbarStrip[];
  contentStrip?: React.ReactNode;
  contentStripIndex?: number;
  contentStripHeight?: number;
  effectiveOrder: string;
  customEndOfResults?: React.ReactNode;
  items: StreamItems;
  onRemove?: (deviation: PapiDeviation, offset: number) => void;
  getItemUrl?: (item: BrowseItem) => string | undefined;
}

const BrowseThumbLayout: React.FC<Props> = ({
  items,
  searchType,
  isInfiniteScroll,
  streamId,
  strips,
  contentStrip = strips?.length ? <Strips /> : null,
  contentStripIndex,
  contentStripHeight,
  layout,
  effectiveOrder,
  customEndOfResults,
  onRemove,
  getItemUrl,
}) => {
  return (
    <BiLoggerContextProvider value={{ sort_type: effectiveOrder }}>
      <OverlayContextProvider value={{ showAuthorTooltip: true }}>
        <PagingWrapper
          streamId={streamId}
          customEndOfResults={customEndOfResults}
        >
          <BrowseDuperContext
            items={items}
            streamId={streamId}
            isLoadMoreAllowed={isInfiniteScroll}
          >
            {layout === BrowseLayout.Torpedo && (
              <BrowseTorpedo
                items={items}
                isInfiniteScroll={isInfiniteScroll}
                contentStrip={contentStrip}
                contentStripIndex={contentStripIndex}
                onRemove={onRemove}
              />
            )}
            {layout === BrowseLayout.Grid && (
              <BrowseGrid
                items={items}
                searchType={searchType}
                contentStrip={contentStrip}
                contentStripIndex={contentStripIndex}
                contentStripHeight={contentStripHeight}
                isInfiniteScroll={isInfiniteScroll}
                onRemove={onRemove}
              />
            )}
            {layout === BrowseLayout.Feed && <BrowseFeed items={items} />}
            {layout === BrowseLayout.Stacked && (
              <BrowseStacks
                items={items}
                getItemUrl={getItemUrl}
                isInfiniteScroll={isInfiniteScroll}
                contentStrip={contentStrip}
                contentStripIndex={contentStripIndex}
                contentStripHeight={contentStripHeight}
                onRemove={onRemove}
              />
            )}
          </BrowseDuperContext>
        </PagingWrapper>
      </OverlayContextProvider>
    </BiLoggerContextProvider>
  );
};
BrowseThumbLayout.displayName = 'BrowseThumbLayout';

export default BrowseThumbLayout;
